import { AppFilter, AppTable, AppTableColumn, AssetsBlockedLists, Country, GroupAppFilter } from '../../_models/models';
import { DateHelper } from '../../_common/date.helper';

const today: Date = DateHelper.getTodayInEasternTime().toDate();
const tomorrow: Date = DateHelper.getTomorrowInEasternTime().toDate();

export const auditEndpoints = {
  PUBLISHER: 'publisher/',
  DEAL: 'deal/',
  DEAL_PARTNER: 'deal-partners/'
};

export const auditTableButtons = [
  { id: 'auditResetFiltersButton', type: 'LINK', title: 'Reset Filters', hasLoadingSpinner: false },
];

export const publisherAuditTableConfig: AppTable = new AppTable('timestamp', 1, 10, 'timestamp',
  'desc', true, true);

export const publisherFieldsToUiMapping = {
  'bcat': { displayName: 'Blocked Categories', matchListName: 'iabCategoriesFlattened', matchProp: 'key', nameProp: 'title' },
  'btype': { displayName: 'Blocked Ad Types', matchListName: 'iabBannerAdTypes', matchProp: 'adTypeId', nameProp: 'description' },
  'battr': { displayName: 'Blocked Creative Attributes', matchListName: 'iabCreativeAttributes', matchProp: 'attributeId', nameProp: 'description' },
  'badv': { displayName: 'Blocked Advertisers' },
  'tldBadv': { displayName: 'Blocked Tld' },
  'bidfloorOpti': { displayName: 'Bid floor adjustment optimization' },
  'commissionOpti': { displayName: 'Commission optimization' },
  'dspAccountExcludeList': { displayName: 'Blocked Dsp', matchListName: 'dspAccounts', matchProp: 'id', nameProp: 'nameDisplay' },
  'dealPartnerExcludeList': { displayName: 'Blocked Curated Marketplace Partners', matchListName: 'dealPartners', matchProp: 'id', nameProp: 'name' },
  'cat': { displayName: 'Categories', matchListName: 'iabCategoriesFlattened', matchProp: 'key', nameProp: 'title' },
  ['publisher.floors.show']: { displayName: 'Show Floor Settings' },
  ['publisher.reporting.detailed']: { displayName: 'Detailed Reporting' },
  ['publisher.reporting.demand']: { displayName: 'Demand Reporting' },
  ['publisher.reporting.deals']: { displayName: 'Deal Reporting' },
  ['publisher.deal.show']: { displayName: 'Deals Section and Spearad' },
  'country': { displayName: 'Country', matchListName: 'countries', matchProp: 'alpha2', nameProp: 'name' },
  'publisherRegionCountryFilters': { displayName: 'Blocked Countries by Region' },
  'tsFeePctOverride': { displayName: 'Traffic Source Fee Override' }
};

const publisherSelectGroups: GroupAppFilter[] = [
  {
    groupId: 1, groupName: 'profileTab', groupDisplayName: 'Profile tab', possibleValues:
      [ { id: 1, displayName: 'Publisher Type', value: 'publisherAccountType' },
        { id: 2, displayName: 'Publisher Initiated Platform Fee', value: 'pubInitiatedDealPlatformfee' },
        { id: 3, displayName: 'Nexxen Initiated Platform Fee', value: 'unrulyInitiatedDealPlatformfee' },
        { id: 4, displayName: 'Accounting ID', value: 'accountingId' },
        { id: 5, displayName: 'Tax ID', value: 'taxId' },
        { id: 6, displayName: 'ZIP ID', value: 'zipId' },
        { id: 7, displayName: 'Internal Notes', value: 'internalNotes' },
        { id: 8, displayName: 'Company Name', value: 'company' }]
  }, {
    groupId: 2, groupName: 'configurationsTab', groupDisplayName: 'Configurations tab', possibleValues:
      [ { id: 1, displayName: 'Bid Floor', value: 'bidFloor' },
        { id: 2, displayName: 'Commission', value: 'commission' },
        { id: 3, displayName: 'Commission Type', value: 'commissionType' },
        { id: 4, displayName: 'Demand Profile', value: 'demandProfile' },
        { id: 5, displayName: 'Floor Adjustment', value: 'floorAdjustment' },
        { id: 6, displayName: 'QPS Defined', value: 'qpsDefined' },
        { id: 7, displayName: 'QPS Limit', value: 'qpsLimit' },
        { id: 8, displayName: 'Traffic Source Fee Override', value: 'tsFeePctOverride' }
      ]
    // {id: 6, displayName: 'Site/App Bundles', value: 'domainBundle'}]
  }, {
    groupId: 3, groupName: 'blockedListsTab', groupDisplayName: 'Blocked Lists tab', possibleValues:
      [ { id: 1, displayName: 'Blocked Categories', value: 'bcat' },
        { id: 2, displayName: 'Blocked Advertisers', value: 'badv' },
        { id: 3, displayName: 'Blocked DSPs', value: 'dspAccountExcludeList' },
        { id: 4, displayName: 'Blocked Curated Marketplace Partners', value: 'dealPartnerExcludeList' },
        { id: 5, displayName: 'Blocked Countries by Region', value: 'publisherRegionCountryFilters' }]
  },
];

const dealPartnerSelectGroups: GroupAppFilter[] = [
  {
    groupId: 1, groupName: 'internalInformation', groupDisplayName: 'Internal Information', possibleValues:
      [ { id: 1, displayName: 'Partner Name', value: 'name' },
        { id: 2, displayName: 'Status', value: 'status' },
        { id: 3, displayName: 'Platform Fee', value: 'platformFee' },
        { id: 4, displayName: 'Platform Fee Type', value: 'platformFeeType' },
        { id: 5, displayName: 'Default Demand Margin', value: 'defaultDemandMargin' }]
  }, {
    groupId: 2, groupName: 'audienceProviders', groupDisplayName: 'Audiences', possibleValues:
      [ { id: 1, displayName: 'Audience Provider', value: 'providerName' },
        { id: 2, displayName: 'Audience Provider ID', value: 'providerId' }]
  }];




// if all audits will be the same - remove publisher prefix from id
export const publisherAuditTableColumns: AppTableColumn[] = [
  { id: 'publisherAuditTimestamp', prop: 'timestamp', displayName: 'Timestamp', type: 'text', isSortEnabled: true },
  { id: 'publisherAuditUsername', prop: 'username', displayName: 'User Name', type: 'text', isSortEnabled: false },
  { id: 'publisherAuditField', prop: 'fieldName', displayName: 'Field Name', type: 'text', isSortEnabled: false },
  { id: 'publisherAuditParent', prop: 'parent', displayName: 'Parent', type: 'text', isSortEnabled: false },
  { id: 'publisherAuditActionType', prop: 'actionType', displayName: 'Action Type', type: 'text', isSortEnabled: false },
  { id: 'publisherAuditPreviousValue', prop: 'previousValue', displayName: 'Previous Value', type: 'text', isSortEnabled: false },
  { id: 'publisherAuditNewValue', prop: 'newValue', displayName: 'New Value', type: 'text', isSortEnabled: false },
];

// Create separate filter configurations for different audit types
const dealPartnerFilters: AppFilter[] = [
  new AppFilter('auditDatesRange', 'DATES_RANGE', 'timestamp', 'Date Range (EST)', '',
    'default', true, false, null, [],
    [today, tomorrow], null, null, null, true,
    [today, tomorrow], null, null,
    null, null, true),
  new AppFilter('auditDealPartnerFieldName', 'SELECT_WITH_GROUPS', 'field', 'Field Name', 'Select field name',
    'multiple', true, false, null,
    [], [],
    null, null, null, false, undefined, undefined, undefined,
    undefined, undefined, undefined, undefined, undefined, undefined, undefined,
    undefined, undefined, undefined, undefined, undefined, undefined, dealPartnerSelectGroups),
  new AppFilter('auditPlatformFee', 'SELECT', 'platformFee', 'Platform Fee', 'Select platform fee',
    'default', true, false, null,
    [
      { id: 1, displayName: 'Demand Margin', value: 'demandMargin' },
      { id: 2, displayName: 'Cost', value: 'cost' }],
    []),
  new AppFilter('auditPartnerUser', 'SELECT', 'userId', 'Partner User', 'Select user',
    'default', true, false, null,
    [],
    [], null,
    null, null, null, []),
  new AppFilter('auditInternalUser', 'SELECT', 'userId', 'Internal User', 'Select user',
    'default', true, false, null,
    [],
    [], null,
    null, null, null, []),
  new AppFilter('auditActionType', 'SELECT', 'action', 'Action Type', 'Select action type',
    'default', true, false, null,
    [
      { id: 1, displayName: 'Create', value: 'INITIAL' },
      { id: 2, displayName: 'Update', value: 'UPDATE' }],
    [])
];

const defaultFilters: AppFilter[] = [
  new AppFilter('auditDatesRange', 'DATES_RANGE', 'timestamp', 'Date Range (EST)', '',
    'default', true, false, null, [],
    [today, tomorrow], null, null, null, true,
    [today, tomorrow], null, null,
    null, null, true),
  new AppFilter('auditFieldName', 'SELECT_WITH_GROUPS', 'field', 'Field Name', 'Select field name',
    'multiple', true, false, null,
    [], [],
    null, null, null, false, undefined, undefined, undefined,
    undefined, undefined, undefined, undefined, undefined, undefined, undefined,
    undefined, undefined, undefined, undefined, undefined, undefined, publisherSelectGroups),
  new AppFilter('auditPublisherUser', 'SELECT', 'userId', 'Publisher User', 'Select user',
    'default', true, false, null,
    [],
    [], null,
    null, null, null, []),
  new AppFilter('auditInternalUser', 'SELECT', 'userId', 'Internal User', 'Select user',
    'default', true, false, null,
    [],
    [], null,
    null, null, null, []),
  new AppFilter('auditActionType', 'SELECT', 'action', 'Action Type', 'Select action type',
    'default', true, false, null,
    [
      { id: 1, displayName: 'Create', value: 'INITIAL' },
      { id: 2, displayName: 'Update', value: 'UPDATE' }],
    [])
];

export const getAuditFiltersConfig = (auditType: string): AppFilter[] => {
  switch (auditType) {
    case 'DEAL_PARTNER':
      return dealPartnerFilters;
    default:
      return defaultFilters;
  }
};

// Replace the existing auditFiltersConfig export with the function
export const auditFiltersConfig = defaultFilters;

export const AUDIT_MOCK_NEW = {
  paginated: true,
  pageNumber: 1,
  pageSize: 10,
  totalElements: 1,
  data: [
    {
      timestamp: 234234234,
      username: 'Bob Sfog',
      field: 'publisherName',
      parent: 'Profile',
      previousValue: 'old name',
      newValue: 'new value',
      action: 'Update'
    }
  ],
};

export interface AuditTranslatableEntities extends AssetsBlockedLists {
  countries?: Country[];
  iabCategoriesFlattened?: Array<{ key: string; title: string }>;
}

export const emptyAuditTranslatableEntitiesObject: AuditTranslatableEntities = {
  countries: [],
  iabCategories: [],
  iabCategoriesFlattened: [],
  iabBannerAdTypes: [],
  iabCreativeAttributes: [],
  dspAccounts: [],
  dealPartners: [],
};
